import { styled } from "@mui/material/styles";
import { Box, TableCell, TableContainer, Table, Paper } from "@mui/material";
import { colors } from "../../../theme/theme";

export const ContentBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const ScrollableTableContainer = styled(TableContainer)(({ theme }) => ({
  overflowX: "auto",
  "&::-webkit-scrollbar": {
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 4,
    backgroundColor: theme.palette.divider,
  },
}));

export const ProgressTable = styled(Table)(({ theme }) => ({
  minWidth: 320,
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontSize: theme.spacing(2),
  fontFamily: "'Gotham', sans-serif",
  fontWeight: "700",
  color: colors.primary,
  lineHeight: "25px",
  textAlign: "left",
  maxWidth: "100px",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
    padding: "7px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    padding: "5px",
  },
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "400",
  color: "rgba(73,42,24,0.5)",
  lineHeight: "15px",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
    padding: "7px",
    ".MuiInputBase-inputAdornedEnd": {
      padding: 10,
    },
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    padding: "5px",
    ".MuiInputBase-inputAdornedEnd": {
      padding: 5,
    },
  },
}));

export const LessonNumberCell = styled(TableCell)(({ theme }) => ({
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "700",
  color: colors.primary,
  lineHeight: "10px",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
    padding: "7px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    padding: "5px",
  },
}));

export const LessonCardPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const LessonCardGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(1),
  alignItems: "center",
}));

export const MobileListBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(1.5),
  [theme.breakpoints.up(660)]: {
    gridTemplateColumns: "1fr 1fr",
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
}));
